export function buildSearchPayload(
  searchTerm: string,
  posjednikId: number
): Record<string, any> {
  return {
    'en~jedinica_gradiva~pretraga_identifikatora': searchTerm.trim(),
    'en~jedinica_gradiva~posjednik': posjednikId,
    $paging_offset: 0,
    $paging_limit: 50
  };
}

export function filterExcluded(results: any[], excludeId: number): any[] {
  return results.filter((item) => item['en~jedinica_gradiva~id'] !== excludeId);
}

export function validateSearchInput(term: string): {
  valid: boolean;
  error?: string;
} {
  const trimmed = term.trim();
  if (trimmed.length < 2) {
    return { valid: false, error: 'Unesite barem 2 znaka' };
  }
  return { valid: true };
}
